import menu from './menu';
import signUp from './signUp';
import solicitudEmpadronamiento from './solicitudEmpadronamiento';
import citaDeEmpadronamiento from './citaDeEmpadronamiento';

import solicitudEmpadronamientoExtranjero from './solicitudEmpadronamientoExtranjero';
import solicitudEmpadronamientoPortalWeb from './solicitudEmpadronamientoPortalWeb'
import fallecidos from './fallecidos'
import cambioPuestoEmpadronamiento from './cambioPuestoEmpadronamiento'
import security from './security';
import dialogoStatus from './dialogoStatus';
import {combineReducers}  from 'redux';

const allReducers = combineReducers({
    security: security,
    menu: menu,
    signUp: signUp,
    solicitudEmpadronamiento:solicitudEmpadronamiento,
    citaDeEmpadronamiento: citaDeEmpadronamiento,
    newCensusRegistration:solicitudEmpadronamiento,
    solicitudEmpadronamientoExtranjero,
    solicitudEmpadronamientoPortalWeb,
    fallecidos,
    cambioPuestoEmpadronamiento,

    dialogoStatus,

});

export default allReducers;